import { Injectable, Injector } from '@angular/core';
import { LOCAL_STORAGE_KEY } from 'src/app/filters/filters.service';

@Injectable()
export class LocalStorageService {
  constructor(private injector: Injector) {}

  setClientId(clientId: number) {
    const currentClientId = window.localStorage.getItem('clientId');
    const id =
      typeof currentClientId === 'string'
        ? parseInt(currentClientId, 10)
        : null;
    if (currentClientId !== id) {
      // Using FiltersService.clearCache creates a circular dependency problem
      window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({}));
    }
    window.localStorage.setItem('clientId', String(clientId));
  }
}
